import { ElementRef } from '@angular/core';
import { Component, OnInit, OnDestroy, AfterViewInit, Injector, ChangeDetectorRef, Inject, PLATFORM_ID, Output, EventEmitter } from '@angular/core';
import { BoxComponent } from '../box/box.component';
import { BoxOpenModeService } from '../../services/boxOpenMode/boxOpenMode.service';
import { dragAndDropSymbol } from '../../services/dragAndDropSymbol/dragAndDropSymbol.service';
import { MobileMainView } from '../../enums/mobile-mainViews';
import { SymbolTypeEnum } from "../../enums/SymbolType.enum";
import { ChartLayoutModeService } from '../../services/chartLayoutMode/chartLayoutMode.service';

@Component({
    selector: 'app-mobile-box',
    template: require('./mobile-box.component.html'),
    styles: [require('./mobile-box.component.scss')]
})
export class MobileBoxComponent extends BoxComponent implements OnDestroy, AfterViewInit, OnInit {

    get render() {
        return fitsInParentBodyVert(this.element.nativeElement, 400);
    }

    @Output('update')
    change: EventEmitter<boolean> = new EventEmitter<boolean>();

    increment() {
        this.change.emit(true);
    }

    


    constructor(@Inject(PLATFORM_ID) platformId: Object,
        injector: Injector,
        openModeService: BoxOpenModeService,
        dragAndDropSymbol: dragAndDropSymbol,
        cdr: ChangeDetectorRef,
        elementRef: ElementRef,
        activeLayoutTypeService: ChartLayoutModeService,
        ) {
        super(platformId, injector, openModeService, dragAndDropSymbol, cdr, activeLayoutTypeService);
    }

    volumes = [
        { label: "1k", value: 1000 },
        { label: "10k", value: 10000 },
        { label: "100k", value: 100000 }
    ];

    ngOnInit() {

    }

    protected _oneClickAllowed: boolean = true;
    public get oneClickAllowed(): boolean {
        if (this.item.Type == SymbolTypeEnum.Index) {
            return false;
        }
        return this._oneClickAllowed;
    }
    public set oneClickAllowed(value: boolean) {
        this._oneClickAllowed = value;
    }

    public get oneClickTrade(): boolean {
        return this.item.oneClickTrade;
    }
    public set oneClickTrade(v: boolean) {
        this.item.oneClickTrade = v;
    }

    public get ChartThumbForSymbol() {
        //this.item.Symbol
        return "/images/chart-pl.png?v=1";
    }

    public set chartView(v: boolean) {
        this.workspace.mobileView = MobileMainView.CHARTING;
        this.globaGridMode.mobileViewUpdate.next("fromwiz");
        this.increment()
    }

    public get tradeSizeLabel(): string {
        return this.item.tradeSizeLabel.replace("Trade size: ", "");
    }

    public set tradeSizeLabel(v: string) {
        this.item.tradeSizeLabel = v;
    }


}

export const fitsInParentBodyVert = function (element: any, tolerance: number = 0) {
    const br = element.getBoundingClientRect();
    const parentBr = element.parentElement.getBoundingClientRect();
    return (br.top >= parentBr.top - tolerance && br.top <= parentBr.bottom + tolerance) || (br.bottom >= parentBr.top - tolerance && br.bottom <= parentBr.bottom + tolerance)
}
